exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".expMapping--header--1CmS3uLY {\r\n  color: #0072CE;\r\n  margin-top: 10px;\r\n  margin-bottom: 0;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/experienceMapping/expMapping.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;CAClB","file":"expMapping.css","sourcesContent":[".header {\r\n  color: #0072CE;\r\n  margin-top: 10px;\r\n  margin-bottom: 0;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "expMapping--header--1CmS3uLY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/experienceMapping/expMapping.css
// module id = 409
// module chunks = 0